// Filename: models/questionnaire/question.js
define('models/questionnaire/answer',[
    'underscore',
    'backbone',
    // src
    'utils',
    'services/api',
], function(_, Backbone, U, API) {

    var MAnswer = Backbone.Model.extend({
        idAttribute: 'questionId',

        isQuestionEmpty: function(question) {
            return _.isEmpty(this.get('question'));
        },

        setQuestion: function(question) {
            this.set('question', question);
        },
    });

    // Return the model for the module
    return MAnswer;
});

